import axios from 'axios';
import { messageService } from '../utils/messageService';
//import { useLogout } from '../utils';
//import { Navigate } from 'react-router-dom';
import { doLogout } from "../utils/authService";
import { navigate } from "../utils/navigation";
//import {useTimeoutStore } from '../store';



// Create axios instance
const axiosInstance = axios.create({
  baseURL: '/controllers/proxy.php',
});

// Add token to every request automatically
axiosInstance.interceptors.request.use((config) => {
  let token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    //const updateTimeout = useTimeoutStore(state => state.updateTimeout)
    // Check if PHP returned a new JWT
    if (response.data?.token) {
      // Update stored JWT
      localStorage.setItem('token', response.data?.token)
      
    }
    localStorage.setItem('timeout', Date.now())
    //updateTimeout(15)
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status == 401) {
      messageService.error(`User session expired`);
    }
    else if (status >= 400 && status < 600) {
      const serverMessage = error.response?.data?.message || error.response?.data?.error;
      const label = status >= 500 ? 'Server error' : 'Request failed';

      messageService.error(`${label} (${status})${serverMessage ? `: ${serverMessage}` : ''}`);
    }
    return Promise.reject(error);
  }
);


axiosInstance.interceptors.response.use(
  r => r,
  error => {
    if (error.response?.status === 401) {


      doLogout();

      //openLogin();


      navigate("/login");  // works!

    }
    return Promise.reject(error);
  }
);

const buildUrl = (path) => `?path=${encodeURIComponent(path)}`;

export const apiClient = {
  get: (path, config = {}) =>
    axiosInstance.get(buildUrl(path), config).then(r => r.data),

  post: (path, data, config = {}) =>
    axiosInstance.post(buildUrl(path), data, config).then(r => r.data),

  put: (path, data, config = {}) =>
    axiosInstance.put(buildUrl(path), data, config).then(r => r.data),

  delete: (path, config = {}) =>
    axiosInstance.delete(buildUrl(path), config).then(r => r.data),
};